import React, { useState, useEffect, useContext } from "react";
import { useHistory, useParams } from "react-router-dom";
import { UserContext } from "../../App";
import { db } from "../../index";
import { createPrice, updatePrice } from "../../utils/price";
import { vehicleOptions, getFilteredVehicleOptions } from "../../utils/vehicles";
import { FooterActionsContainer } from "../layout/Footer";
import {OutlineButton} from "../layout/OutlineButton";


function defaultVehiclesPrices() {
  let res = {};

  vehicleOptions.forEach((vehicle) => {
    res[vehicle.value] = {
      client: 0,
      partner: 0,
    };
  });

  return res;
}

function defaultProducts() {
  return [
    {
      id: "minPrice",
      label: "Prix minimum",
      vehicles: { ...defaultVehiclesPrices() },
    },
    {
      id: "kmPrice",
      label: "Prix au km",
      vehicles: { ...defaultVehiclesPrices() },
    },
    {
      id: "hourPrice",
      label: "Prix à l'heure",
      vehicles: { ...defaultVehiclesPrices() },
    },
  ];
}

export default function PriceAddOrUpdateContent() {
  const history = useHistory();
  const params = useParams();
  const priceId = params.price_id;

  const { userInfos } = useContext(UserContext);
  const filteredVehicleOptions = getFilteredVehicleOptions(userInfos);

  const [price, setPrice] = useState({
    cityName: "",
    products: [...defaultProducts()],
  });

  const [isFetching, setIsFetching] = useState(false);
  const [newProductName, setNewProductName] = useState("");

  useEffect(() => {
    if (priceId && userInfos?.uid) {
      setIsFetching(true);
      db.ref(`users/${userInfos.uid}/CityTariffs/${priceId}`)
        .once("value")
        .then((snapshot) => {
          const res = snapshot.val();

          if (res) {
            if (!res.products) res.products = [...defaultProducts()];
            setPrice(res);
          }
        })
        .finally(() => {
          setIsFetching(false);
        });
    }
  }, [priceId, userInfos.uid]);

  function handleChange(e) {
    const { name, value } = e.target;
    setPrice((prevCity) => ({
      ...prevCity,
      [name]: value,
    }));
  }

  function addProduct(e) {
    e.preventDefault();

    setPrice((old) => ({
      ...old,
      products: [
        ...old.products,
        {
          id: "(Produit) " + newProductName,
          label: "(Produit) " + newProductName,
          vehicles: { ...defaultVehiclesPrices() },
        },
      ],
    }));

    setNewProductName("");
  }

  function deleteProduct(e, productId) {
    e.preventDefault();

    setPrice((old) => ({
      ...old,
      products: old.products.filter((p) => p.id !== productId),
    }));
  }

  function handleTariffChange(e, productId, vehicleType, userType) {
    const { value } = e.target;
    setPrice((old) => {
      let res = { ...old };
      let currentProduct = res.products.find((p) => p.id === productId);
      if (!currentProduct) return res;

      currentProduct.vehicles[vehicleType][userType] = value
        ? parseFloat(value)
        : 0;

      let currentProductIndex = res.products.findIndex(
        (p) => p.id === productId
      );
      res.products.splice(currentProductIndex, 1, currentProduct);

      return res;
    });
  }

  async function handleFormSubmit(e) {
    e.preventDefault();
    setIsFetching(true);

    if (priceId) {
      await updatePrice(userInfos, price);
      window.alert("Tarif mis à jour avec succès");
    } else {
      await createPrice(userInfos, price);
      history.push("/price");
    }

    setIsFetching(false);
  }

  return (
    <div className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor">
      <form onSubmit={handleFormSubmit} className="kt-form">
        <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
          <div className="kt-portlet">
            <div className="kt-portlet__head">
              <div className="kt-portlet__head-label">
                <h3 className="kt-portlet__head-title">
                  {priceId && price?.cityName
                    ? `Tarif "${price?.cityName}"`
                    : "Création d'un tarif"}
                </h3>
              </div>
            </div>
            <div className="kt-portlet__body">
              <div className="form-group row">
                <label
                  className="col-lg-3 col-form-label"
                  style={{ color: "#000" }}
                >
                  Nom de la grille tarifaire:
                </label>
                <div className="col-lg-6">
                  <input
                    type="text"
                    className="form-control"
                    name="cityName"
                    value={price.cityName}
                    onChange={handleChange}
                    disabled={isFetching}
                    required
                  />
                </div>
              </div>

              <div className="form-group row">
                <label
                  className="col-lg-3 col-form-label"
                  style={{ color: "#000" }}
                >
                  Ajouter un produit
                </label>
                <div className="col-lg-6">
                  <div className="input-group">
                    <input
                      style={{ borderWidth: "1px", height: "100%" }}
                      type="text"
                      className="form-control"
                      value={newProductName}
                      onKeyDown={(e) => e.key === "Enter" && addProduct(e)}
                      onChange={(e) => setNewProductName(e.target.value)}
                    />
                    <div className="input-group-append">
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={addProduct}
                        disabled={isFetching}
                      >
                        Ajouter
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <table>
                <thead>
                  <tr>
                    <th></th>
                    {price.products.map((product, index) => (
                      <th key={product.id}>
                        {index > 2 ? (
                          <button
                            className="text-danger"
                            style={{ border: "none", background: "none" }}
                            onClick={(e) => deleteProduct(e, product.id)}
                          >
                            X
                          </button>
                        ) : (
                          ""
                        )}
                        {product.label}
                      </th>
                    ))}
                  </tr>
                  {filteredVehicleOptions
                    // .filter((v) => v.value !== "meetngreet")
                    .map((vehicle) =>
                      ["client", "partner"].map((userType) => (
                        <tr key={vehicle.value + "-" + userType}>
                          <th>
                            {vehicle.label}{" "}
                            {userType === "client" ? "Client" : "Chauffeur"}
                          </th>
                          {price.products.map((product) => (
                            <td
                              key={`${product.id}-${vehicle.value}-${userType}`}
                            >
                              <input
                                className="form-control"
                                type="number"
                                value={
                                  product.vehicles[vehicle.value][userType]
                                }
                                onChange={(e) =>
                                  handleTariffChange(
                                    e,
                                    product.id,
                                    vehicle.value,
                                    userType
                                  )
                                }
                              />
                            </td>
                          ))}
                        </tr>
                      ))
                    )}
                </thead>
              </table>

              <FooterActionsContainer className="mt-5">
                <div>
                  <OutlineButton
                    type="button"
                    onClick={() => history.push("/price")}
                    disabled={isFetching}
                  >
                    <i className="fas fa-arrow-left" />
                    Retour
                  </OutlineButton>
                </div>
                <div>
                  <button
                    type="submit"
                    className="btn btn-primary px-5"
                    disabled={isFetching}
                  >
                    {priceId ? "Mettre à jour" : "Créer"} le tarif
                  </button>
                </div>
                <div></div>
              </FooterActionsContainer>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}
